module.exports = __webpack_public_path__ + "img/logo-text-black.36d8b178.png";